import {Component, OnInit, ViewChild} from '@angular/core';
import {Grid} from '../../../../shared/Models/grid';
import {Router} from '@angular/router';
import {PropertyService} from '../../../Services/property.service';
import {ActionColumn, ActionItem, TextColumn} from '../../../../shared/Models/columns';
import {Property} from '../../../Models/Property';
import {TranslateService} from '@ngx-translate/core';
import {HttpParams} from '@angular/common/http';
import {concat, Observable, of, Subject} from 'rxjs';
import {catchError, debounceTime, distinctUntilChanged, filter, switchMap, tap} from 'rxjs/operators';
import {Supplier} from '../../../Models/Supplier';
import {BroadcastService} from '../../../../shared/Services/broadcast.service';

@Component({
  selector: 'app-property-overview',
  templateUrl: './property-overview.component.html',
  styleUrls: ['./property-overview.component.scss']
})
export class PropertyOverviewComponent implements OnInit {
  public grid: Grid;
  public propertyId: number;
  public propertyName: string;
  public properties: Observable<Supplier[]>;
  public propertiesLoading = false;
  public propertiesinput$ = new Subject<string>();
  @ViewChild('propertyRowDetail', {static: false}) propertyRowDetail: any;
  @ViewChild('deleteModal', {static: false}) deleteModal = null;

  constructor(private router: Router, private propertyService: PropertyService, private translate: TranslateService ,private broadcastService: BroadcastService) {
  }

  ngOnInit() {
    this.loadProperty();
    this.grid = <Grid>{
      columns: [
        <TextColumn>{
          name: 'doctrine.property.name',
          prop: 'name',
          sortable: true,
          type: TextColumn.type,
          translate: true
        },
        <TextColumn>{
          name: 'doctrine.property.description',
          prop: 'description',
          sortable: true,
          type: TextColumn.type,
          translate: true,
          responsiveHideCallback: (width) => width < 1024
        },
        <TextColumn>{
          name: 'doctrine.property.status',
          prop: 'status',
          sortable: false,
          type: TextColumn.type,
          translate: true,
          valueFormatter: row => {
            if (row) {
              return this.translate.instant('global.amount');
            }
            return this.translate.instant('global.meter');
          }
        },
        <ActionColumn>{
          name: 'global.actions',
          prop: null,
          type: ActionColumn.type,
          sortable: false,
          translate: true,
          actionItems: [
            < ActionItem > {
              icon: 'fa fa-pencil fa-lg',
              tooltip: 'global.edit',
              onclick: row => this.router.navigateByUrl('back-office/property/' + row.id),
              showCallback: row => row,
              btnClass: 'ripple light'
            },
            <ActionItem>{
              icon: 'fa fa-remove fa-lg',
              tooltip: 'global.remove',
              onclick: row => {
                this.propertyId = row.id;
                this.propertyName = row.name.bold();
                this.deleteModal.show();
                // return this.router.navigateByUrl('back-office/property/' + row.id + '/show');
              },
              showCallback: row => row.code !== Property.PROPERTY_FABRIC_AMOUNT,
              btnClass: 'ripple light ms-1'
            },
          ]
        }
      ],
      service: this.propertyService,
      rememberURL: this.router.url,
      method: 'getProperty',
      defaultSort: 'id',
      rowDetailTemplate: this.propertyRowDetail,
      rowDetailShowCallback: (row, size) => size < 1400,
      defaultSortType: 'desc',
      showButton: true
    };
  }

  public softDelete() {
    this.propertyService.softDeleteProperty(this.propertyId).subscribe((res) => {
      this.deleteModal.hide();
      this.broadcastService.broadcast('refreshGrid', 'getProperty');
    });
  }
  private loadProperty() {
    let params = new HttpParams();
    this.properties = concat(
      of([]), // default items
      this.propertiesinput$.pipe(
        debounceTime(200),
        distinctUntilChanged(),
        filter(query => query && query.length > 2),
        tap(() => {this.propertiesLoading = true; params = params.append('excludeValue', this.propertyId.toString());}),
        switchMap((term) => this.propertyService.getPropertyReplace(params.set('query', term)).pipe(
          catchError(() => of([])), // empty list on error
          tap((res) => {
            this.propertiesLoading = false;
          })
        ))
      )
    );
  }
  goToArchive() {
    this.router.navigateByUrl('back-office/property/archive');

  }
}
